<template>
  <div :class="'dashboard__crew p-4  mark-' + index" :style="'--max-height--mark: 125px'">
    <h3 class="mb-0">
      <button class="dashboard__crew__title" @click="toggle(index, 'mark-', true)">
        {{ title }}
        <FontAwesomeIcon icon="fa-light fa-chevron-down"></FontAwesomeIcon>
      </button>
    </h3>
    <div class="dashboard__crew__item">
      <div class="dashboard__triad">
        <div class="dashboard__triad__apprentice d-flex align-items-center">
          <span v-if="apprenticeProfileLabel && apprenticeProfileLabel.titleAbbreviation" class="badge -apprentice">{{
            apprenticeProfileLabel.titleAbbreviation.toUpperCase()
          }}</span>
          <span v-if="apprenticeProfileLabel && apprenticeProfileLabel.title" class="d-flex align-items-center">
            <span
              v-tooltip="{
                title: apprenticeProfileLabel.title,
              }"
              class="name"
            >
              {{ apprenticeProfileLabel.title }}
            </span>
          </span>
          <span v-else>{{ $t("apprentice") }}</span>
        </div>
        <div class="d-flex align-items-center">
          <span v-if="tutorProfileLabel && tutorProfileLabel.titleAbbreviation" class="badge -tutor">{{
            tutorProfileLabel.titleAbbreviation.toUpperCase()
          }}</span>
          <span
            v-if="tutorProfileLabel && tutorProfileLabel.title"
            v-tooltip="{
              title: tutorProfileLabel.title,
            }"
            class="name"
          >
            {{ tutorProfileLabel.title }}
          </span>
          <span v-else>{{ $t("tutor") }}</span>
        </div>
        <div class="d-flex align-items-center">
          <span
            v-if="apprenticeMasterProfileLabel && apprenticeMasterProfileLabel.titleAbbreviation"
            class="badge -apprenticeMaster"
            >{{ apprenticeMasterProfileLabel.titleAbbreviation.toUpperCase() }}</span
          >
          <span
            v-if="apprenticeMasterProfileLabel && apprenticeMasterProfileLabel.title"
            v-tooltip="{
              title: apprenticeMasterProfileLabel.title,
            }"
            class="name"
          >
            {{ apprenticeMasterProfileLabel.title }}
          </span>
          <span v-else>{{ $t("apprenticeMaster") }}</span>
        </div>
        <div v-if="studeaManagerProfileLabel && studeaManagerProfileLabel.title" class="d-flex align-items-center">
          <span class="badge -leaManager">CL</span>
          <span
            v-tooltip="{
              title: studeaManagerProfileLabel.title,
            }"
          >
            {{ studeaManagerProfileLabel.title }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { studeaManagerManager } from "@/services/studea-manager/studea-manager-manager";
import { mapState } from "pinia";
import { usePlatformStore } from "@/store/platform/platform";
export default {
  name: "AccordionMarkHeadColumnComponent",
  components: {},
  props: {
    title: {
      type: String,
      required: true,
      default: "",
    },
    index: {
      type: Number,
      required: true,
      default: 0,
    },
  },
  computed: {
    ...mapState(usePlatformStore, {
      apprenticeProfileLabel: (store) => store.apprenticeProfileLabel,
      tutorProfileLabel: (store) => store.tutorProfileLabel,
      apprenticeMasterProfileLabel: (store) => store.apprenticeMasterProfileLabel,
      studeaManagerProfileLabel: (store) => store.studeaManagerProfileLabel,
    }),
  },
  methods: {
    toggle(item, name, isMultipleElement) {
      studeaManagerManager.toggle(item, name, isMultipleElement);
    },
  },
};
</script>

<style lang="scss" scoped>
.dashboard {
  &__crew {
    border-bottom: 1px solid #e0e6ed;
    text-align: center;
    background-color: $lighter-grey;

    &__title {
      width: 100%;
      background-color: var(--primary-color);
      opacity: 0.5;
      color: $white;
      border-radius: 6px;
      padding: 5px 20px;
      border: none;
      display: flex;
      justify-content: space-between;
      align-items: center;
      svg {
        transform: rotate(0deg);
        transition: all 300ms ease-in-out;
        margin-left: 10px;
      }
    }

    &__item {
      transition: all 300ms ease-in-out;
      overflow: hidden;
      height: 0;
    }

    &.on {
      .dashboard__crew__item {
        height: var(--max-height--mark);
      }

      .dashboard__crew__title {
        svg {
          transform: rotate(-180deg);
        }
      }
    }
  }

  &__triad {
    padding: 15px 0;
    border-bottom: 1px dashed #e0e6ed;
    height: 135px;
    cursor: pointer;

    div {
      display: flex;
      justify-content: start;
      margin-top: 5px;
      margin-left: 20px;
    }

    .name {
      display: block;
      max-width: 100px;
      margin-right: 10px;
      cursor: default;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    &:last-child {
      padding-bottom: 0;
      border-bottom: none;
    }

    &__apprentice {
      font-weight: 700;
    }
  }
}

.badge {
  width: 20px;
  height: 20px;
  font-size: 0.5rem;
  padding: 3px 4px;
  margin-right: 15px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;

  &:hover {
    cursor: default;
  }

  &.-apprentice {
    background: $green;
  }

  &.-tutor {
    background: $purple;
  }

  &.-apprenticeMaster {
    background: $red;
  }

  &.-leaManager {
    background: $orange;
  }
}

.mark-0 {
  border-top: 3px solid #e0e6ed;
}
</style>
